import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=89b34eb8&scoped=true"
var script = {}
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=89b34eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b34eb8",
  null
  
)

export default component.exports